import { Container } from "./container";

export function Footer() {
  return (
    <div className="min-h-[100px] pt-2 pb-4 px-5 bg-black text-white">
      <Container className="md:flex justify-between">
        <div className="flex flex-col flex-1/3">© 2026 Agile Architchs AB</div>
      </Container>
    </div>
  );
}
